 <!-- <section class="FirstScroll_Section">
    <div class="container nopad">
    <div class="row text-center">
    <h2 class="SectionHeading">Departments</h2>
    </div>


    <div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12 nopad">
<div *ngFor="let department of departments" class="padding">
    <mat-accordion>
        <div>  
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>{{department?.department}}</mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <div class="col-md-12 col-sm-12 col-xs-12 pad">
                <table>
                  <thead>
                    <tr>
                      <th scope="col" style="width: 25%;">S.No.</th>
                      <th scope="col" style="width: 25%;">Year</th>
                      <th scope="col" style="width: 50%;">Specialization</th>
                      <th scope="col" style="width: 50%;">Syllabus</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let topic of department['topics']; let i=index;">
                      <td scope="row" data-label="S.No." style="width: 25%;">{{i+1}}</td>
                      <td data-label="Year" style="width: 25%;">{{topic?.year_id}}</td>
                      <td data-label="Specialization" style="width: 50%;">{{topic?.topic}}</td>
                      <td data-label="Syllabus" style="width: 50%;">{{topic?.topic}} </td>
                    </tr>
                  </tbody>
                </table>      </div>
        </mat-expansion-panel>
        
        </div>
    </mat-accordion>
</div>
    </div>
    </div> -->

    <section class="FirstScroll_Section">
      <div class="container nopad aboutContainer">
          <div class="aboutSubContainer text-center">
              <h2 class="HeadingText">Departments</h2>
              <!-- <p class="AboutContentText"></p> -->
          </div>
          <div class="filter text-center">
          <form autocomplete="off" [formGroup]="deptForm" (submit)="onSubmit(deptForm.value)">
            <mat-form-field [floatLabel]="'never'" class="col-4">
                <mat-label>Select Department</mat-label>
                <mat-select formControlName="dept" required>
                    <!-- <mat-option value="16">Aptitude</mat-option>
                    <mat-option value="15">Chemistry</mat-option>
                    <mat-option value="2">Civil Engineering</mat-option>     
                    <mat-option value="1">Computer Science and Engineering</mat-option>
                    <mat-option value="17">Ek Bharat Shrestha Bharat</mat-option>
                    <mat-option value="5">Electrical Engineering</mat-option>
                    <mat-option value="3">Electronics and Communication Engineering</mat-option>
                    <mat-option value="14">Emerging Areas</mat-option>
                    <mat-option value="7">Maths</mat-option>
                    <mat-option value="13">MBA</mat-option>
                    <mat-option value="18">MCA</mat-option>
                    <mat-option value="4">Mechanical Engineering</mat-option>
                    <mat-option value="6">Physics</mat-option>
                    <mat-option value="19">PGDM</mat-option> -->
                    <mat-option *ngFor="let department of departments" [value]="department?.id">{{department?.department}}</mat-option>
                </mat-select>
            </mat-form-field>
        
            <button class="searchBtn" type="submit">Apply Filter</button>
        </form>
      </div>
      </div>
      <div class="clearfix"></div>
  </section>
  <div class="clearfix"></div>

  <div id="listView" class="container bannerSection boxShadow tab-pane active" *ngIf="topics">
    <div class="col-md-12 col-sm-12 col-xs-12 nopad">
      <table>
        <thead>
          <tr>
            <th scope="col">S.No.</th>
            <th scope="col">Specialization</th>
            <th scope="col">Year of Study</th>
            <th scope="col">View Syllabus</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let topic of topics; let i=index;">
          <tr>
            <td scope="row" data-label="sno" class="deptSerial">{{i+1}}</td>
            <td data-label="subject" class="deptTitle">{{topic?.topic}}</td>
            <td data-label="date" class="deptYear">{{topic?.year_id}}</td>
            <td data-label="file" class="deptPreview">
              <a style="cursor: pointer;" (click)="showSyllabus(topic?.syllabus)">
                <mat-icon matTooltip="Preview">remove_red_eye</mat-icon>
              </a>
            </td>
          </tr>
          <tr class="syllabus" *ngIf="isShown && syllabus==topic?.syllabus">
            <td colspan="4">
              <div class="syllabusHeading">Syllabus :</div><br>
              <div class="syllabusBody">{{syllabus}}</div>
              </td>
          </tr>
          </ng-container>
        </tbody>
        
      </table>
     </div>
    <div class="clearfix"></div>
  </div>